// TODO: Remember to remove eslint-disable comments
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import i18n from 'i18n-react';
import Carousel from 'nuka-carousel';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ContentHeader from 'components/ContentHeader';
import Modal from 'components/Modal';
import Progress from 'components/Progress';
import ShareBox from 'components/ShareBox';
import TrainingCard from 'components/TrainingGrid/TrainingCard';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { useChapters } from 'hooks/useChapters';
import { useSettings } from 'hooks/useSettings';

import { storageKeys } from 'settings';

const trackShare = (chapterNumber, name) => {
  const value = `chapter-${chapterNumber}`;
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'Guest';
      ({ email } = userObj);
      APIHandler.trackEvent(appId, email, 'retention', 'chapter', window.location.href, name).then(() => {});
    });
  });
};

// Renders a specfic section (category) of grouped training links (chapters), including facts, progress, etc.
const TrainingExtraView = ({ match }) => {
  const { id } = match.params;

  const { chapters, categories } = useChapters();
  const {
    appId,
    lang: { code, langFile },
  } = useSettings();

  const [showBadgePopout, setShowBadgePopout] = useState(false);

  const handleBadgeOpen = () => {
    setShowBadgePopout(true);
  };
  const handleBadgeClose = () => setShowBadgePopout(false);

  const pageCategory = useMemo(
    () => categories.find((foundCategory) => foundCategory.id === Number(id)),
    [categories, id],
  );
  const {
    facts = [],
    translatedFacts = {},
    percentage: percentageFloat = 0,
    badge = '',
    title = '',
    image,
    color = '',
  } = pageCategory || {};

  const percentage = useMemo(() => Math.round(percentageFloat), [percentageFloat]);

  // Filters the chapters for only the relevant chapters for this category. Will be the working list for this page.
  const filteredChapters = useMemo(
    () =>
      chapters.filter((chapter) => {
        const { id: chapterID } = chapter;
        const { chapterIDs } = pageCategory;
        return chapterIDs.includes(chapterID);
      }),
    [chapters, pageCategory],
  );

  // Renders the facts for this category. If there are no facts, renders a default message.
  const renderedFacts = useMemo(() => {
    const locale = `${langFile}-${langFile.toUpperCase().replace('PT', 'BR').replace('ES', '41').replace('KO', 'KR')}`;
    console.log(locale);
    if (!facts || facts.length === 0) {
      return (
        <div className="slide">
          <p>{i18n.translate('trainingExtraScreens.noFactsFound.description')}</p>
        </div>
      );
    }

    if (locale in translatedFacts && translatedFacts[locale].length > 0) {
      return translatedFacts[locale].map(({ id: factID, description: factDescription }) => (
        <div key={factID} className="slide">
          <p>{factDescription}</p>
        </div>
      ));
    }

    return facts.map(({ id: factID, description: factDescription }) => (
      <div key={factID} className="slide">
        <p>{factDescription}</p>
      </div>
    ));
  }, [facts, langFile, code, translatedFacts]);

  // renders a subset of the filtered chapters to only include the completed chapters
  const renderedCompletedChapters = useMemo(() => {
    const classes = clsx(
      'trainingCard__Animated',
      'trainingExtraView__chapter',
      'trainingExtraView__chapter--uncompleted',
    );
    return filteredChapters
      .filter(({ percentage: chapterPercentage }) => chapterPercentage === 100)
      .map((chapter) => {
        const { id: chapterID, title: chTitle } = chapter;
        return (
          <div className={classes} key={`ch${chapterID}`} onClick={() => trackShare(chapterID, chTitle)}>
            <TrainingCard appId={appId} chapter={chapter} redirPath="/main/retain/chapter/" />{' '}
            {/* FIXME: Temporarily removed the extra in retain/extra/chapter due to BackButton logic interfering */}
          </div>
        );
      });
  }, [appId, filteredChapters]);

  // renderes a subset of the filtered chapters to only include the uncompleted chapters
  const renderedUncompletedChapters = useMemo(() => {
    const classes = clsx(
      'trainingCard__Animated',
      'trainingExtraView__chapter',
      'trainingExtraView__chapter--uncompleted',
    );
    return filteredChapters
      .filter(({ percentage: chapterPercentage }) => chapterPercentage < 100)
      .map((chapter) => {
        const { id: chapterID, title: chTitle } = chapter;
        return (
          <div className={classes} key={`ch${chapterID}`} onClick={() => trackShare(chapterID, chTitle)}>
            <TrainingCard appId={appId} chapter={chapter} redirPath="/main/training/extra/chapter/" />
          </div>
        );
      });
  }, [appId, filteredChapters]);

  // Will determine how the completion visualisation is rendered (just text, a badge image, both, etc.)
  const renderedCompletionBox = useMemo(() => {
    if (!filteredChapters || filteredChapters.length === 0) {
      const classes = clsx('trainingExtraView__score-container', 'trainingExtraView__score-container--message');
      return (
        <div className={classes}>
          <h6 className="trainingExtraView__current-score">
            {i18n.translate('trainingExtraScreens.noAvailableBadges')}
          </h6>
        </div>
      );
    }

    const { total, completed } = filteredChapters.reduce(
      (acc, chapter) => {
        const { percentage: chapterPercentage } = chapter;
        acc.total += 1;
        if (chapterPercentage === 100) acc.completed += 1;
        return acc;
      },
      { total: 0, completed: 0 },
    );

    if (total < completed) {
      const classes = clsx('trainingExtraView__score-container', 'trainingExtraView__score-container--message');
      return (
        <div className={classes}>
          <h6 className="trainingExtraView__current-score">{i18n.translate('trainingExtraScreens.error')}</h6>
        </div>
      );
    }

    if (window.location.pathname.includes('retain')) {
      return <div />;
    }

    if (total === completed) {
      const classes = clsx('trainingExtraView__score-container', 'trainingExtraView__score-container--badges');
      const btnClasses = clsx('trainingExtraView__badge-button', 'trainingExtraView__badge-button--round');
      const imgClasses = clsx('trainingExtraView__badge', 'trainingExtraView__badge--round');
      return (
        <React.Fragment>
          <div className={classes}>
            <button type="button" className={btnClasses} onClick={() => handleBadgeOpen()}>
              <img src={badge} alt={title} className={imgClasses} />
            </button>
          </div>
          <Modal show={showBadgePopout} onHide={handleBadgeClose} bgClose autosize>
            {/* FIXME: TEMP Props */}
            <ShareBox
              image={badge}
              url={badge}
              title={title}
              subject={i18n.translate('sharing.shareSubjectBadge')}
              body={i18n.translate('sharing.shareBodyBadge', { chapterTitle: title })}
              email
              download
              size="sm"
            />
          </Modal>
        </React.Fragment>
      );
    }

    const classes = clsx('trainingExtraView__score-container', 'trainingExtraView__score-container--message');

    return (
      <div className={classes}>
        <h6 className="trainingExtraView__current-score">
          {i18n.translate('trainingExtraScreens.interimScore')}
          <span>{total - completed}</span>
          {i18n.translate('trainingExtraScreens.interimScoreEnd')}
        </h6>
      </div>
    );
  }, [badge, filteredChapters, showBadgePopout, title]);

  const locale = `${langFile.toLowerCase()}-${langFile
    .replace('pt', 'BR')
    .replace('es', '41')
    .replace('ko', 'kr')
    .toUpperCase()}`;
  let subHeadTitle = pageCategory?.title;
  if (langFile !== 'en' && pageCategory?.translations?.length > 0) {
    subHeadTitle = pageCategory?.translations.find((t) => t.locale === locale)?.title || subHeadTitle;
  }

  return (
    <div className="contentContainer trainingExtraView">
      <ContentHeader header={subHeadTitle} subtitle={i18n.translate('trainingExtraScreens.subtitle')}>
        {renderedCompletionBox}

        <div className="container__Progress">
          <div className="container__progressBar">
            <Progress id="progress" value={percentage} />

            <div className="mapTop">
              <div className="left">
                <img src={image} alt="map" />
              </div>
              <div className="right">
                <Carousel
                  autoplayInterval={5000}
                  autoplay={renderedFacts.length > 1}
                  wrapAround
                  pauseOnHover
                  withoutControls={renderedFacts.length <= 1}
                  renderCenterLeftControls={({ previousSlide }) => (
                    <button type="button" onClick={previousSlide}>
                      <FontAwesomeIcon icon={['fas', 'angle-left']} />
                    </button>
                  )}
                  renderCenterRightControls={({ nextSlide }) => (
                    <button type="button" onClick={nextSlide}>
                      <FontAwesomeIcon icon={['fas', 'angle-right']} />
                    </button>
                  )}
                >
                  {renderedFacts}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </ContentHeader>
      <div className="trainingGrid trainingExtraView__grid">
        {renderedUncompletedChapters.length > 0 && (
          <React.Fragment>
            <h1 className="trainingExtraView__collection-title">
              {i18n.translate('trainingExtraScreens.uncompletedTitle', { partner: subHeadTitle })}{' '}
            </h1>
            {renderedUncompletedChapters}
          </React.Fragment>
        )}
        {renderedCompletedChapters.length > 0 && (
          <React.Fragment>
            <h1 className="trainingExtraView__collection-title">
              {i18n.translate('trainingExtraScreens.completedTitle', { partner: subHeadTitle })}{' '}
            </h1>
            {renderedCompletedChapters}
          </React.Fragment>
        )}
      </div>
      {color && (
        <style>
          {`
        :root {
          --section-color: ${color};
        }
      `}
        </style>
      )}
    </div>
  );
};

TrainingExtraView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape().isRequired,
  }).isRequired,
};

export default TrainingExtraView;
